import apiClient from "common/src/api/ApiClient";

// Fetches the app-wide config (currently just the configured timezone) once at bootstrap - see
// AppTimeZoneProvider on the backend.
export async function fetchAppConfig() {
  const response = await apiClient.get("/api/v1/config");
  return response.data.payload;
}
